
import onlineCo2 from "./onlineCo2"

export default [
    ...onlineCo2
]